import {
  AdminSpinner,
  Box,
  Div,
  formatNumber,
  getDashboardTrackingSuccessRateDeliveries,
  H3,
  H5,
  Icon,
  lightTheme,
  P,
  Separator,
  TrackingSuccessRateEntity,
  VDriveLogo,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { GraphWrapper } from '../../DashboardStyled';
import { dataTrackingSuccessRate } from '../../dummyData';

async function getBestPerformingCustomers(
  setTrackingSuccessRate: Dispatch<
    SetStateAction<TrackingSuccessRateEntity | null>
  >,
  setLoading: Dispatch<SetStateAction<boolean>>
) {
  setLoading(true);

  try {
    const { data } = await getDashboardTrackingSuccessRateDeliveries();

    setTrackingSuccessRate(data.data);
  } catch (error) {
    reportError(error);
  } finally {
    setLoading(false);
  }
}

export const SuccessTrackingRateSection = () => {
  const [loading, setLoading] = useState(false);
  const [trackingSuccessRate, setTrackingSuccessRate] =
    useState<TrackingSuccessRateEntity | null>(null);

  useEffect(() => {
    getBestPerformingCustomers(setTrackingSuccessRate, setLoading);
  }, []);

  return (
    <Box $p="16px 20px" $relative>
      {loading && <AdminSpinner small absolute creme />}

      <H5 $mb="16">Tracking SMS Delivery Success</H5>

      <Div $flex $alignCenter>
        <Div $width="40%">
          <Div>
            <P $m="0" $bold>
              Success SMS
            </P>
            <Div $flex $alignCenter $columnSM $alignStartSM>
              <H3 $color={lightTheme.green} $m="0">
                {formatNumber(trackingSuccessRate?.successPercentage || 0)}%
              </H3>
            </Div>
          </Div>

          <Separator $m="10px 0" />

          <Div>
            <P $m="0" $bold>
              Failed SMS
            </P>
            <Div $flex $alignCenter $columnSM $alignStartSM>
              <H3 $color={lightTheme.primary} $m="0">
                {formatNumber(trackingSuccessRate?.failurePercentage || 0)}%
              </H3>
            </Div>
          </Div>
        </Div>

        {trackingSuccessRate && (
          <GraphWrapper style={{ position: 'relative' }}>
            <Icon
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
              $size={window.innerWidth < 800 ? 60 : 100}
            >
              <VDriveLogo />
            </Icon>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart width={400} height={400}>
                <Pie
                  data={dataTrackingSuccessRate(trackingSuccessRate)}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  // label={renderCustomizedLabel}
                  outerRadius={window.innerWidth < 800 ? 80 : 120}
                  innerRadius={window.innerWidth < 800 ? 30 : 50}
                  fill="#000000"
                  dataKey="value"
                >
                  {dataTrackingSuccessRate(trackingSuccessRate).map(
                    (entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    )
                  )}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </GraphWrapper>
        )}
      </Div>
    </Box>
  );
};
